module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsShow__preview__box__panel__links__a-ff0a203f2b8bb2d97487bbdebd1c237c.svg";